import { createAction } from '@ngrx/store';

export const DashboardOpenedAction = createAction('[Dashboard] Dashboard Opened');
